export default __webpack_public_path__ + "static/media/mdu.af9d7ba6.jpg";